import WhatsappIcon from './Whatsapp.icon';

export default WhatsappIcon;
